import * as React from "react";
import styled from "styled-components";
import {Grid} from "@mui/material";
import Background1 from "../../img/foreign-book-background-1.png";
import Background2 from "../../img/foreign-book-background-2.png";
import ForeignCover1 from "../../img/foreign-cover-1.jpg";
import ForeignCover2 from "../../img/foreign-cover-2.jpg";
import ForeignCover3 from "../../img/foreign-cover-3.jpg";
import {Colors} from "../../theme/colors";
import {StyledButton} from "../ui-base/button";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

export const ForeignBooksDashboard = () => {
    const { t } = useTranslation('publisher');

    return (
        <StyledMainGrid container direction={"row"} alignContent={"center"}>
            <Grid item xs={12} sm={6} container direction={"column"} spacing={1}>
                <Grid item>
                    <StyledTitle1>
                        {t('foreignAdvertisement.preTitle')}
                    </StyledTitle1>
                </Grid>

                <Grid item>
                    <StyledTitle2>
                        {t('foreignAdvertisement.title')}
                    </StyledTitle2>
                </Grid>

                <Grid item>
                    <StyledDescription>
                        <span style={{fontWeight: "bold"}}>{t('foreignAdvertisement.preDesc')}</span><br/>
                        {t('foreignAdvertisement.desc')}
                    </StyledDescription>
                </Grid>

                <Grid item style={{marginTop: '2rem'}}>
                    <Link to={'/publisher/book-market'}>
                        <StyledButton type={"button"} color={"violet"}>{t('foreignAdvertisement.showButton')}</StyledButton>
                    </Link>
                </Grid>
            </Grid>

            <Grid item xs={12} sm={6} container direction={"row"} spacing={2} alignItems={"center"} justifyContent={"center"}>
                <Grid item>
                    <StyledImg src={ForeignCover1}/>
                </Grid>

                <Grid item>
                    <StyledImg src={ForeignCover2}/>
                </Grid>

                <Grid item>
                    <StyledImg src={ForeignCover3}/>
                </Grid>
            </Grid>
            <StyledBackground1 src={Background1}/>
            <StyledBackground2 src={Background2}/>
        </StyledMainGrid>
    )
}

const StyledMainGrid = styled(Grid)`
  position: relative;
  min-height: 320px;
  background: #FFFFFF;
  border-radius: 4px;
  padding: 20px;
  border: 1px solid #E0E0E0;
  filter: drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.12));
  overflow: hidden;
`;

const StyledBackground1 = styled('img')`
  position:absolute;
  top: -60px;
  right: -250px;
  z-index: -1;
`;

const StyledBackground2 = styled('img')`
  position:absolute;
  top: -80px;
  right: -50px;
  z-index: -2;
`;

const StyledTitle1 = styled('h4')`
  color: ${Colors.violet};
  font-weight: 600;
  font-size: 1.3rem;
`;

const StyledTitle2 = styled('h3')`
  color: ${Colors.violet};
  font-weight: 600;
  font-size: 1.8rem;
`;

const StyledDescription = styled('p')`
  color: ${Colors.grayText};
  font-size: 0.9rem;
`;

const StyledImg = styled('img')`
  height: 200px;
  -webkit-box-shadow: -11px 0px 50px -34px ${Colors.neutral30};
  -moz-box-shadow: -11px 0px 50px -34px ${Colors.neutral30};
  box-shadow: -11px 0px 50px -34px ${Colors.neutral30};
`;
